import { useEffect, useMemo, useState } from "react";
import api from "../lib/api";

const GROUP_ORDER = ["Staff Tecnico", "Dirigenza", "Staff Social", "Società"];

export default function Team() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/staff").then((r) => setStaff(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const grouped = useMemo(() => {
    const map = {};
    GROUP_ORDER.forEach((g) => (map[g] = []));
    staff.forEach((s) => {
      if (!map[s.group]) map[s.group] = [];
      map[s.group].push(s);
    });
    return map;
  }, [staff]);

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 py-20" data-testid="team-page">
      <p className="font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-gold mb-4">Dietro ogni vittoria</p>
      <h1 className="font-display font-black uppercase text-6xl sm:text-8xl lg:text-9xl text-white leading-[0.85] tracking-[0.02em] mb-16" data-testid="team-title">
        Il Nostro <span className="text-gold">Team</span>
      </h1>

      {loading && <p className="text-zinc-400 font-mono text-sm" data-testid="team-loading">Caricamento staff...</p>}

      {Object.entries(grouped).map(([group, members]) =>
        members.length > 0 ? (
          <section key={group} className="mb-16" data-testid={`team-group-${group.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="flex items-center gap-4 mb-8">
              <span className="h-1 w-12 bg-gold" />
              <h2 className="font-display font-black uppercase text-4xl sm:text-5xl text-white leading-none">{group}</h2>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {members.map((m) => (
                <article key={m.id} data-testid={`staff-card-${m.id}`} className="grey-fade border border-line border-l-4 border-l-gold p-7 hover:bg-carddark transition-colors">
                  <h3 className="font-display font-black uppercase text-3xl text-white leading-none">{m.name}</h3>
                  <p className="font-mono text-xs tracking-[0.2em] uppercase text-gold mt-2">{m.role}</p>
                  {m.birth_year && (
                    <p className="font-mono text-[10px] tracking-widest uppercase text-zinc-500 mt-5 border-t border-line pt-3">
                      Classe {m.birth_year}
                    </p>
                  )}
                </article>
              ))}
            </div>
          </section>
        ) : null
      )}
    </main>
  );
}
